import { useQuery } from '@tanstack/react-query'
import { ticketAppIncidentQuery } from '../api/appIncidents'
import './TicketBands.css'

/**
 * Banda incidentului de aplicatie pe fisa tichetului.
 *
 * Pe tichetul unei alarme legate: "Part of incident: Charisma ERP unavailable"
 * cu legatura la tichetul aplicatiei. Pe tichetul aplicatiei (parintele):
 * "Application incident: Charisma ERP" si componentele cu alarmele lor.
 *
 * Fara incident, fara drept sau inainte de migrare, banda nu se deseneaza:
 * fisa ramane exact cum era.
 */
export function TicketAppIncident({ id }: { id: number }) {
  const { data } = useQuery({ ...ticketAppIncidentQuery(id), retry: false })
  const incident = data?.ready ? data.incident : null
  if (!incident) return null

  const tone = incident.state === 'unavailable' ? 'label-danger' : 'label-warning'

  if (incident.role === 'child') {
    return (
      <div className="tk-family tk-app-incident" id="ticketAppIncident">
        <div className="tk-family-row">
          <span className="tk-family-label">Part of incident</span>
          <a href={`/app/easeedesk/ticket/${incident.ticketId}`} target="_blank" rel="noopener noreferrer">
            #{incident.ticketId} {incident.subject}
          </a>{' '}
          <span className={`label ${tone}`}>{incident.open ? incident.state : 'closed'}</span>
        </div>
      </div>
    )
  }

  return (
    <div className="tk-family tk-app-incident" id="ticketAppIncident">
      <div className="tk-family-row">
        <span className="tk-family-label">Application incident</span>
        <a href={`/app/applications/${incident.appId}`} target="_blank" rel="noopener noreferrer">{incident.appName}</a>{' '}
        <span className={`label ${tone}`}>{incident.open ? incident.state : 'closed'}</span>
      </div>
      {incident.tickets.length > 0 && (
        <div className="tk-family-row">
          <span className="tk-family-label">
            Alarms <span className="tk-family-count">{incident.tickets.length}</span>
          </span>
          <div className="tk-family-list">
            {incident.tickets.map((t) => (
              <div key={t.id}>
                {t.component && <strong>{t.component}: </strong>}
                <a href={`/app/easeedesk/ticket/${t.id}`} target="_blank" rel="noopener noreferrer">
                  #{t.id} {t.subject}
                </a>{' '}
                <span className="text-muted small">{t.closed ? 'closed' : t.status}</span>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  )
}
